/**
 * @module user settings
 */
const statuses = {
  active: 'active',
  pending: 'pending',
  deactivated: 'deactivated',
};

// This is a hardcoded mapping from the static string values used on the server
// to the values used in the UI.
const serverStatuses = {
  ACTIVE: statuses.active,
  INVITATION_PENDING: statuses.pending,
  DISABLED: statuses.deactivated,
};

// This is a hardcoded reverse mapping from the values used in UI to those used
// on the server.
const reverseServerStatuses = {
  [statuses.active]: 'ACTIVE',
  [statuses.pending]: 'INVITATION_PENDING',
  [statuses.deactivated]: 'DISABLED',
};

// a virtual role id used to filter users by who have not been assigned to a role
const emptyRoleId = 0;

export { statuses, serverStatuses, reverseServerStatuses, emptyRoleId };
